import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import {
  actions as ordersActions,
  selectors as ordersSelectors,
} from 'state/orders';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { isEmpty } from 'utils/types';

import PaginationButton from 'components/orders/PaginationButton/component';

const enhance = compose(
  connect(
    (state) => ({
      hasMorePages: !isEmpty(ordersSelectors.getPages(state)),
      isFetching: ordersSelectors.isFetching(state),
    }),
    {
      fetchMore: ordersActions.fetchMoreOrders,
      sendEvent: analyticsActions.sendEvent,
    }
  ),
  withHandlers({
    fetchMore:
      ({ sendEvent, fetchMore, type }) =>
      () => {
        sendEvent(analyticsEvents.orders.list.paginationRequested({ type }));
        fetchMore({ type });
      },
  })
);

export default enhance(PaginationButton);
